enum SafetyDepositPaymentType {
    NONE = "Geen borg",
    VIA_NATURE_HOUSE = "Via Natuurhuisje betalingen",
    VIA_OWNER = "Ter plaatse",
}

export default SafetyDepositPaymentType;
